import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, switchMap, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import { WebhookActions } from './webhook.actions';
import { WebhookService } from '../../api-services/dealer/dealer_webhook.service';
import { AppActions } from '../app/app.actions';

@Injectable()

export class WebhookEffects {
  private actions$ = inject(Actions)

  constructor(
    private webhookService: WebhookService,
  ) { }

  loadWebhooks$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebhookActions.loadWebhooks),
      concatMap(() =>
        this.webhookService.getWebhooks().pipe(
          switchMap(data => [
            WebhookActions.loadWebhooksSuccess({ data }),
            AppActions.setLoading({ loading: false })
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  createWebhook$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebhookActions.createWebhook),
      concatMap((payload) =>
        this.webhookService.createWebhook(payload.payload).pipe(
          switchMap(data => [
            WebhookActions.createWebhookSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            WebhookActions.loadWebhooks()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  updateWebhook$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebhookActions.updateWebhook),
      concatMap((payload) =>
        this.webhookService.updateWebhook(payload.payload).pipe(
          switchMap(data => [
            WebhookActions.updateWebhookSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            WebhookActions.loadWebhooks()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  deleteWebhook$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebhookActions.deleteWebhook),
      concatMap((payload) =>
        this.webhookService.deleteWebhook(payload.id).pipe(
          switchMap(data => [
            WebhookActions.deleteWebhookSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            WebhookActions.loadWebhooks()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  testWebhook$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WebhookActions.testWebhook),
      concatMap((payload) =>
        this.webhookService.testWebhook(payload.id).pipe(
          switchMap(data => [
            WebhookActions.testWebhookSuccess({ data }),
            AppActions.setLoading({ loading: false }),
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

}
